import React, { useEffect } from 'react';
import './ourservicesnew.css';
import img1 from '../../assets/dsigniibgimage/img5.jpeg';
import img2 from '../../assets/dsigniibgimage/img4.jpeg';
import img3 from '../../assets/dsigniibgimage/img1.jpg';
import img4 from '../../assets/dsigniibgimage/img2.jpg';
import AOS from 'aos';
import 'aos/dist/aos.css';

const serviceData = [
  {
    img: img1,
    title: 'Web Designing',
    description: 'Creative, responsive, and user-friendly designs that make your brand stand out in the digital world.',
    link: '/web',
  },
  {
    img: img2,
    title: 'SEO',
    description: 'Optimize your website to rank higher in search engines and drive organic traffic to your business.',
    link: '/seo',
  },
  {
    img: img3,
    title: 'Digital Marketing',
    description: 'Grow your online presence with strategic marketing across social platforms, ads, and email campaigns.',
    link: '/digital',
  },
  {
    img: img4,
    title: 'Logo Design',
    description: 'Professional logos that reflect your brand identity and leave a lasting impression on your audience.',
    link: '/logo',
  },
];

function Oursrvicesnew() {


  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    setTimeout(() => {
      AOS.refresh();
    }, 500);
  }, []);

  return (
    <div className='container-fluid web-containers'>
      <div className="feature">
        <section className='section-margin' style={{ marginTop: '0px' }}>
          <center>
            <div className='heading-for-all' data-aos="fade-up" style={{ marginTop: '10px', marginBottom: '20px' }}>
              <h2>Our Services</h2>
            </div>
          </center>
        </section>

        <div className="container">
          <div className="row">
            {serviceData.map((service, index) => (
              <div key={index} className="col-md-3 col-sm-6 col-xs-12">
                <div className="feature-main">
                  <div className="feature-box" data-aos="fade-up" data-aos-delay="1000">
                    <img src={service.img} className="img-responsive" alt={service.title} />
                    <div className="cover"></div>
                  </div>
                  <div className="feature-head">
                    <h3 data-aos="fade-up" data-aos-delay="1000">{service.title}</h3>
                    <p data-aos="fade-up" data-aos-delay="2000">{service.description}</p>
                    <span
                      data-aos="fade-up"
                      data-aos-delay="3000"
                      className="learn-more"
                      style={{ display: 'inline-block', cursor: 'pointer' }}
                      onClick={() => window.location.href = service.link}
                    >
                      Learn More <i className="fa fa-angle-double-right"></i>
                    </span>
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Oursrvicesnew;
